import React, { useEffect, useRef } from 'react';
import styles from './SearchSlide.module.scss';
import { useNavigate } from 'react-router-dom';
import { Transition } from 'react-transition-group';
import { SFAutocompleteRefHandler, SFBackgroundLight } from 'sfui';
import { SearchTopic } from '../../SearchTopic/SearchTopic';
import { Topic } from '../../../Models';

const TRANSITION_TIMEOUT = 480;

const defaultStyle: React.CSSProperties = {
  backgroundColor: SFBackgroundLight,
  height: '60px',
  position: 'absolute',
  zIndex: 2,
  transition: `width ${TRANSITION_TIMEOUT}ms ease-in-out`,
  width: '100%'
};

const transitionStyles: { [index: string]: React.CSSProperties } = {
  entered: { width: 0 },
  exited: { width: '100%' }
};

export interface SearchSlideProps {
  show: boolean;
  topics: Topic[];
  onHide: () => void;
}

export const SearchSlide = ({
  show,
  topics,
  onHide
}: SearchSlideProps): React.ReactElement<SearchSlideProps> => {
  const navigate = useNavigate();
  const onSelect = (value: string) => {
    onHide();
    navigate(`/topic/${value}`);
  };

  const ref = useRef<SFAutocompleteRefHandler>(null);

  useEffect(() => {
    if (show && ref.current) {
      setTimeout(() => {
        ref.current?.focus();
      }, TRANSITION_TIMEOUT);
    }
  }, [show]);

  return (
    <Transition
      appear
      in={show}
      timeout={{
        appear: 0,
        enter: TRANSITION_TIMEOUT,
        exit: TRANSITION_TIMEOUT
      }}
    >
      {(state) => (
        <div className={`${styles.searchSlide} ${!show ? styles.hidden : ''}`}>
          <div
            style={{
              ...defaultStyle,
              ...transitionStyles[state as string]
            }}
          ></div>

          <SearchTopic
            ref={ref}
            topics={topics}
            onSelect={onSelect}
            onBlur={onHide}
          />
        </div>
      )}
    </Transition>
  );
};
